import React from 'react';

const LoadingSpinner = () => (
  <div className="flex justify-center items-center">
    <div className="relative">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="h-12 w-12 rounded-full border-t-2 border-b-2 border-blue-500 dark:border-blue-400 animate-spin"></div>
      </div>
      <div className="h-12 w-12 rounded-full border-r-2 border-l-2 border-transparent border-t-blue-300 dark:border-blue-600/50 animate-pulse"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="h-4 w-4 bg-blue-500 dark:bg-blue-400 rounded-full animate-pulse"></div>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;